<section fxLayout.xs="column" fxLayoutAlign.xs="start center">
  <div class="number">
    <span>{{number}}</span>
  </div>
</section>
